import { Draggable } from '@hello-pangea/dnd'
import { Box } from '@chakra-ui/react'
import DragHandler from './DragHandler'
import React, { useContext } from 'react'
import { TreeItemAccordion, TreeItemStatic } from './TreeItem'
import { TreeViewDroppable } from './TreeViewDroppable'
import { TreeViewContext } from './TreeViewContext'

export const TreeViewDraggable = ({ data, disableClick, disableAccordion }) => {
  const { readOnly } = useContext(TreeViewContext)
  return data.map((item, index) => {
    return (
      <Draggable
        isDragDisabled={readOnly}
        key={item.id}
        draggableId={item.id}
        index={index}>
        {(provided, snapshot) => (
          <Box
            ref={provided.innerRef}
            {...provided.draggableProps}>
            <Box
              // maxW="400px"
              pl="16px"
              position="relative"
              backgroundColor={snapshot.isDragging ? 'gray.50' : 'white'}>
              {!readOnly && <DragHandler provided={provided} />}
              <TreeItemWrapper
                disableAccordion={disableAccordion}
                readOnly={readOnly}
                data={item}
                disableClick={disableClick}>
                <TreeViewDroppable
                  data={item.children}
                  type={item.type}
                  parentId={item.id}
                  droppableId={item.id}
                  sectionName={item.name}
                  disableAccordion={disableAccordion}
                />
              </TreeItemWrapper>
            </Box>
          </Box>
        )}
      </Draggable>
    )
  })
}

const TreeItemWrapper = ({
  data,
  disableClick,
  readOnly,
  children,
  disableAccordion,
}) => {
  if (!readOnly && !disableAccordion) {
    return (
      <TreeItemAccordion
        data={data}
        disableClick={disableClick}>
        {children}
      </TreeItemAccordion>
    )
  } else {
    if (data.children && data.children.length !== 0 && !disableAccordion) {
      return (
        <TreeItemAccordion
          data={data}
          disableClick={disableClick}>
          {children}
        </TreeItemAccordion>
      )
    } else {
      return (
        <TreeItemStatic
          data={data}
          disableClick={disableClick}>
          {children}
        </TreeItemStatic>
      )
    }
  }
}
